import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import DashboardLayout from "./layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import AIRecordings from "./pages/AIRecordings";

import ProtectedRoute from "./routes/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Login */}
        <Route path="/" element={<Login />} />

        {/* Dashboard Layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute roles={["it_admin", "admin", "user", "agent"]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >

          {/* Dashboard → Only IT Admin */}
          <Route
            index
            element={
              <ProtectedRoute roles={["it_admin"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Users → Only IT Admin */}
          <Route
            path="users"
            element={
              <ProtectedRoute roles={["it_admin"]}>
                <Users />
              </ProtectedRoute>
            }
          />

          {/* AI Recordings → All Users */}
          <Route
            path="ai-recordings"
            element={
              <ProtectedRoute roles={["it_admin", "admin", "user", "agent"]}>
                <AIRecordings />
              </ProtectedRoute>
            }
          />

        </Route>

      </Routes>
    </BrowserRouter>
  );
}